import React, {useState, useEffect} from "react";
import GenericItem from "./GenericItem";

const ClickToCopyItem = ({title, details, cssClasses}) => {
    const originalDetails = `${details} ${i18n.common.clickToCopy}`;
    const [detailsToUse, setDetailsToUse] = useState(originalDetails);

    const onClick = (e) => {
        setDetailsToUse(`${details} ${i18n.common.copied}`);
        navigator.clipboard.writeText(details);
        setTimeout(resetDetails, 3000);
    };

    const resetDetails = () => {
        if (detailsToUse !== originalDetails) {
            return;
        }
        setDetailsToUse(originalDetails);
    }

    return (
        <div onClick={onClick} className={'click-to-copy-item'}>
            <GenericItem title={title} details={detailsToUse} cssClasses={cssClasses}/>
        </div>
    );
}

export default ClickToCopyItem;